import Product from '../models/Product';

interface ProductCardProps {
  product: Product;
  extended: boolean;
}

const ProductCard: React.FC<ProductCardProps> = ({ product, extended }) => {
  const cardStyle: React.CSSProperties = {
    display: 'inline-block',
    minWidth: '300px',
    maxWidth: '300px',
    margin: '10px',
    padding: '10px',
    border: '1px #ccc',
    borderRadius: '8px',
    textAlign: 'center'
  };

  const imageStyle: React.CSSProperties = {
    maxWidth: '100%',
    maxHeight: '200px',
    objectFit: 'cover',
    marginBottom: '16px'
  };

  const textBoxStyle: React.CSSProperties = {
    maxWidth: '100%',
    maxHeight: '200px',
    objectFit: 'cover',
    marginBottom: '16px',
    textAlign: 'left'
  };

  const descriptionStyle: React.CSSProperties = {
    wordWrap: 'break-word',
    overflow: 'hidden',
    whiteSpace: 'pre-wrap',
    minHeight: '50px',
    maxHeight: '120px'
  };

  return (
    <div className="ProductCardBox" style={cardStyle}>
      <img src={process.env.PUBLIC_URL + product.imgPath} alt="product" style={imageStyle} />
      <div style={textBoxStyle} >
        <h3>{product.name}</h3>
        {extended &&
          <div>
            <p style={descriptionStyle}>{product.description}</p>
            <p style={{ fontSize: '1em' }}>Price available on enquiry.</p>
          </div>
        }
      </div>

    </div>

  );
};

export default ProductCard;